import BasicObject from '../BasicObject';
import * as THREE from 'three';
import { COLORS_CONST } from '../../../helpers/styles';

export class CircleCrossMove extends BasicObject {
  material = new THREE.MeshBasicMaterial({
    color: COLORS_CONST.blue,
    transparent: true,
    opacity: 0.4,
  });
  constructor() {
    super();
    this.name = 'circle_move';

    this.buildGeometry();
  }

  buildGeometry() {
    super.buildGeometry();
    this.geometry = new THREE.CircleGeometry(0.15, 32);
    this.geometry.applyMatrix4(new THREE.Matrix4().makeRotationX(-Math.PI / 2));

    const p1 = new THREE.Vector3(0, this.position.y, -0.4);
    const p2 = new THREE.Vector3(0, this.position.y, 0.4);
    const p3 = new THREE.Vector3(-0.4, this.position.y, 0);
    const p4 = new THREE.Vector3(0.4, this.position.y, 0);
    this.createCrossLine(p1, p2);
    this.createCrossLine(p3, p4);
  }
  removeMesh() {
    super.removeMesh(this);
  }

  private createCrossLine(p1: THREE.Vector3, p2: THREE.Vector3) {
    const geometry = new THREE.Geometry().setFromPoints([p1, p2]);
    const material = new THREE.LineBasicMaterial({ color: 0x000000, linewidth: 1 });
    const line = new THREE.LineLoop(geometry, material);
    this.add(line);
  }
}
